import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import ArrowForwardIOS from '@material-ui/icons/ArrowForwardIos'

const styles = theme => ({
  container: {
    width: '100%',
    display: 'flex',
    cursor: 'pointer',
    padding: '20px 0',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  label: {
    textAlign: 'left',
    pointerEvents: 'none',
    textTransform: 'none',
    color: theme.palette.black,
  },
  underline: {
    borderBottom: `1px solid ${theme.palette.background.medium}`,
  },
})

class ArrowButton extends React.PureComponent {
  onPress = () => {
    const { link, onPress } = this.props
    if (onPress) {
      onPress(link)
    }
  };

  render() {
    const {
      classes, className, label, underline, hideArrow 
    } = this.props

    return (
      <div
        onClick={this.onPress}
        className={classNames(
          className,
          classes.container,
          underline && classes.underline
        )}>
        <span className={classes.label}>{label}</span>
        {!hideArrow && (
          <ArrowForwardIOS color="primary" style={{ fontSize: 20 }} />
        )}
      </div>
    )
  }
}

ArrowButton.propTypes = {
  link: PropTypes.string,
  label: PropTypes.string,
  onPress: PropTypes.func,
  hideArrow: PropTypes.bool,
  classes: PropTypes.object,
  underline: PropTypes.bool,
  className: PropTypes.string,
}

export default withStyles(styles)(ArrowButton)



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/ArrowButton.js